import React, { useState } from "react";
import { Drawer, Grid, Typography, Chip, makeStyles, Button, Divider } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { SearchSelect, SubmitButton } from "../../../../../";
import { Debug } from "../../../../Forms/Debug";
import _ from "lodash";
var useStyles = makeStyles(function (theme) {
  return {
    drawerContainer: {
      padding: "24px",
      width: "380px"
    },
    chip: {
      border: "2px solid " + theme.palette.text.primary,
      borderRadius: "4px",
      minWidth: "80px",
      background: "transparent",
      fontSize: "20px"
    },
    containerMetrics: {
      display: "flex"
    },
    containerMetric: {
      margin: "12px",
      display: "flex",
      flexDirection: "column"
    },
    title: {
      fontWeight: "600"
    },
    mt12: {
      marginTop: "12px"
    },
    my12: {
      margin: "12px 0"
    },
    card: {
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px 0"
    },
    cardText: {
      marginTop: "8px"
    },
    cardIconText: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px"
    },
    mr30: {
      marginRight: "30px"
    },
    icon: {
      margin: "8px"
    },
    mt8: {
      marginTop: "8px"
    },
    divider: {
      margin: "4px 0"
    },
    containerDelete: {
      height: "100vh",
      display: "flex",
      alignItems: "center"
    },
    alignCenter: {
      width: "100%",
      textAlign: "center"
    },
    iconDelete: {
      fontSize: "128px",
      textAlign: "center",
      width: "100%"
    },
    iconUser: {
      fontSize: "80px",
      textAlign: "center",
      width: "100%"
    },
    iconActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});

var CampusSingleDrawerSatisfaction = function CampusSingleDrawerSatisfaction(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: props.open,
    onClose: props.toggleDrawer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.drawerContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, props.translation ? props.translation.title || "Satisfaction" : "Satisfaction", " ", "> ", props.data ? props.data.parent || "" : "")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.texts ? props.translation.texts.repeat || "Would you repeat the experience?" : "Would you repeat the experience?" : "Would you repeat the experience?", " ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "24px"
    }
  }, props.data ? props.data.recommends ? props.data.recommends.repeat ? props.translation ? props.translation.options ? props.translation.options.yes || "Yes" : "Yes" : "Yes" : props.translation ? props.translation.options ? props.translation.options.no || "No" : "No" : "No" : "" : ""))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.texts ? props.translation.texts.recommend || "Would you recommend ... to a friend or acquaintance?" : "Would you recommend ... to a friend or acquaintance?" : "Would you recommend ... to a friend or acquaintance?"), /*#__PURE__*/React.createElement("div", {
    className: [classes.containerMetrics, classes.my12].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, " ", props.translation ? props.translation.chips ? props.translation.chips.sportmadness || "Sportmadness" : "Sportmadness" : "Sportmadness"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.data ? props.data.recommends ? props.data.recommends.sportmadness || "0" : "0" : "0", "/5")
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, " ", props.translation ? props.translation.chips ? props.translation.chips.campus || "Campus" : "Campus" : "Campus"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.data ? props.data.recommends ? props.data.recommends.service || "0" : "0" : "0", "/5")
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.my12
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.texts ? props.translation.texts.proposal || "This is how you valued your value proposition?" : "This is how you valued your value proposition?" : "This is how you valued your value proposition?"), /*#__PURE__*/React.createElement("div", {
    className: [classes.containerMetrics, classes.my12].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, props.translation ? props.translation.chips ? props.translation.chips.venues || "Venues" : "Venues" : "Venues"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.data ? props.data.metrics ? props.data.metrics.find(function (metric) {
      return metric.name === "venues";
    }) ? props.data.metrics.find(function (metric) {
      return metric.name === "venues";
    }).rating || "0" : "0" : "0" : "0", "/5")
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, props.translation ? props.translation.chips ? props.translation.chips.activities || "Activities" : "Activities" : "Activities"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.data ? props.data.metrics ? props.data.metrics.find(function (metric) {
      return metric.name === "activities";
    }) ? props.data.metrics.find(function (metric) {
      return metric.name === "activities";
    }).rating || "0" : "0" : "0" : "0", "/5")
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, props.translation ? props.translation.chips ? props.translation.chips.trainers || "Staff" : "Staff" : "Staff"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.data ? props.data.metrics ? props.data.metrics.find(function (metric) {
      return metric.name === "trainers";
    }) ? props.data.metrics.find(function (metric) {
      return metric.name === "trainers";
    }).rating || "0" : "0" : "0" : "0", "/5")
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.containerMetrics
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, props.translation ? props.translation.texts ? props.translation.texts.app || "What assessment have you given to the app as a communication tool?" : "What assessment have you given to the app as a communication tool?" : "What assessment have you given to the app as a communication tool?"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.data ? props.data.metrics ? props.data.metrics.find(function (metric) {
      return metric.name === "app";
    }) ? props.data.metrics.find(function (metric) {
      return metric.name === "app";
    }).rating || "0" : "0" : "0" : "0", "/5")
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.my12
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, props.translation ? props.translation.texts ? props.translation.texts.highlights || "What would you highlight?" : "What would you highlight?" : "What would you highlight?"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.data ? props.data.comments ? props.data.comments.highlights || "" : "" : "")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, props.translation ? props.translation.texts ? props.translation.texts.improve || "What would you improve?" : "What would you improve?" : "What would you improve?"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.data ? props.data.comments ? props.data.comments.improve || "" : "" : ""))));
};

export { CampusSingleDrawerSatisfaction };